<template>
  <div
    :class="{ 'is-reverse': reverse }"
    class="drop__title
    LKRoadmapsFeedToggleLine"
  >
    <IconToggle
      :active="active"
      :loading="loading"
      class="mod--files"
    />
    <v-badge
      :value="!active && newCount > 0"
      :content="newCount"
      inline
      :color="color"
    >
      <div class="text-md mod--files">
        {{ label }}
      </div>
    </v-badge>
    <div class="LKRoadmapsFeedToggleLine__space" />
    <div class="files__line" />
  </div>
</template>

<script>
import variables from '@/assets/scss/exports.scss'
import IconToggle from '@/components/lk/icons/LKIconToggle.vue'


export default {
  name: 'LKRoadmapsFeedToggleLine',
  components: {
    IconToggle,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    newCount: Number,
    reverse: Boolean,
    loading: Boolean,
    active: Boolean,
  },
  data: () => ({
    color: variables['webflow-color-blue'],
  }),
}
</script>

<style lang="scss">
.LKRoadmapsFeedToggleLine {
  display: flex;
  transition: opacity 0.25s;

  &:hover {
    opacity: 1;
  }

  &__space {
    flex-shrink: 1;
    width: 12px;
  }

  &.is-reverse {
    flex-direction: row-reverse;
  }
}
</style>
